var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { Icon } from 'elements';
import { Tooltip } from 'reactstrap';
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            tooltip: false
        };
        _this.handleToggleTooltip = function () {
            _this.setState(function (prev) { return ({ tooltip: !prev.tooltip }); });
        };
        return _this;
    }
    Select.prototype.render = function () {
        var _a = this.props, value = _a.value, options = _a.options, label = _a.label, placeholder = _a.placeholder, underline = _a.underline, onChange = _a.onChange, multiple = _a.multiple, id = _a.id, tooltipContent = _a.tooltipContent, props = __rest(_a, ["value", "options", "label", "placeholder", "underline", "onChange", "multiple", "id", "tooltipContent"]);
        var unfolded = !!value;
        var heigh = options.length * 32;
        // console.log('value: ', String(value))
        // console.log('options: ', options)
        return (React.createElement(Wrapper, __assign({ id: id }, props, { underline: underline, label: label, multiple: multiple }),
            !multiple && label ? React.createElement(Label, { unfolded: unfolded }, label) : null,
            !multiple && (React.createElement(StyledSelect, { value: value, label: label, onChange: onChange },
                placeholder ? React.createElement("option", { value: '' }, placeholder) : null,
                options.map(function (option) { return (React.createElement("option", { key: option.name + String(option.value), value: option.value }, option.name)); }))),
            !multiple && React.createElement(StyledIcon, { name: "arrow" }),
            multiple && (React.createElement("div", null,
                React.createElement(LabelMultiple, null, label),
                React.createElement(StyledMultiSelect, { heigh: heigh, multiple: true, defaultValue: mapOptions(options), 
                    /*label={label}*/
                    onChange: onChange },
                    placeholder ? React.createElement("option", { value: '' }, placeholder) : null,
                    options.map(function (option) { return (React.createElement("option", { style: {
                            paddingTop: '6px',
                            paddingLeft: '20px',
                            height: '25px'
                        }, key: option.name, value: option.value }, option.name)); })))),
            id && (React.createElement(Tooltip, { target: id, isOpen: this.state.tooltip, toggle: this.handleToggleTooltip }, tooltipContent))));
    };
    Select.defaultProps = {
        underline: true
    };
    return Select;
}(Component));
export default Select;
// return array selected
var mapOptions = function (options) {
    var positions = [];
    options.forEach(function (value) {
        if (value.selected) {
            positions.push(value.value);
        }
    });
    return positions;
};
var height = Math.ceil(Theme.common.size.font * Theme.common.size.lineHeight) +
    Theme.common.size.font +
    1 +
    'px';
var Wrapper = cxs('div')(function (_a) {
    var id = _a.id, underline = _a.underline, label = _a.label, multiple = _a.multiple;
    return (__assign({ position: 'relative', margin: Theme.size.space[1], 
        // margin: `auto ${Theme.size.space[1]}`,
        height: multiple ? '100%' : label ? height : undefined }, (underline && !multiple
        ? {
            borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline)
        }
        : undefined)));
});
Wrapper.propTypes = {
    underline: PropTypes.bool,
    label: PropTypes.string
};
var Label = cxs('label')(function (_a) {
    var unfolded = _a.unfolded;
    return ({
        position: 'absolute',
        display: 'block',
        height: Theme.fontSize.regular,
        fontSize: unfolded ? Theme.fontSize.small : Theme.fontSize.regular,
        color: Theme.color.placeholder,
        transform: "translateY(10)",
        zIndex: -1,
        transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    });
});
var LabelMultiple = cxs('label')(function (_a) {
    var unfolded = _a.unfolded;
    return ({
        marginTop: '10px',
        // position: 'absolute',
        // display: 'block',
        height: Theme.fontSize.regular,
        fontSize: unfolded ? Theme.fontSize.small : Theme.fontSize.regular,
        color: Theme.color.placeholder,
        /*transform: `translateY(${unfolded ? 0 : 0})`,*/
        zIndex: -1
        /*transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'*/
    });
});
Label.propTypes = {
    unfolded: PropTypes.bool
};
LabelMultiple.propTypes = {
    unfolded: PropTypes.bool
};
var StyledSelect = cxs('select')(function (_a) {
    var label = _a.label;
    return (__assign({ width: '100%', height: '100%', paddingRight: Theme.size.space[3] }, (label ? { paddingTop: Theme.fontSize.regular, height: height } : null)));
});
StyledSelect.propTypes = {
    label: PropTypes.string
};
var StyledMultiSelect = cxs('select')(function (_a) {
    var heigh = _a.heigh;
    return ({
        width: '100%',
        height: "".concat(heigh, "px"),
        overflow: 'hidden'
    });
});
StyledMultiSelect.propTypes = {
    height: PropTypes.number
};
var StyledIcon = cxs(Icon)({
    position: 'absolute',
    right: 0,
    bottom: 0,
    transform: 'rotate(90deg)',
    padding: 0,
    zIndex: -1
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/Select.tsx
// module id = 409
// module chunks = 0